export function convertToK(value) {
  // Check if value is greater than or equal to 1000
  if (value >= 1000) {
    // Divide the value by 1000 and add the "k" suffix
    return (value / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  // Return the value unchanged if it's less than 1000
  return value.toString();
}
